import { useDispatch, useSelector } from 'react-redux';
import { setNavigationSubTitle, setNavigationTitle } from '../../Store/Actions/navigationHeaderActions';
import { useEffect, useMemo } from 'react';
import Avatar from '../Utility/Avatar';
import ChatInput from '../Chat/ChatInput/ChatInput';
import { ChatMessageRole } from '../../Types/Enums';

interface HomeProps {
    initMessage?: string;
}

function Home({ initMessage }: HomeProps) {
    const i18n = useSelector((state: any) => state.i18n.i18n);
    const dispatch = useDispatch();

    const basePrompt = useSelector((state: any) => state.environment.basePrompt);
    const selectedPrompt = useSelector((state: any) => state.environment.selectedPrompt);

    const prompts = useSelector((state: any) => state.chats.prompts);
    const prompt = prompts.find((prompt: any) => prompt.identifier === selectedPrompt) || basePrompt;

    useEffect(() => {
        dispatch(setNavigationSubTitle(''));
        dispatch(setNavigationTitle(''));
    }, [dispatch]);

    const chatInputComponent = useMemo(() => {
        return <ChatInput giveExamples={true} initMessage={initMessage} />;
    }, [initMessage]);

    return prompt ? (
        <div className="flex justify-center items-center h-full w-full">
            <div className="h-fit w-full max-w-[1280px] px-5 md:px-20 flex flex-col items-center">
                <div className="flex flex-col gap-3 items-center mb-3 relative">
                    <Avatar
                        role={ChatMessageRole.assistant}
                        avatarImage={prompt.image}
                        title={prompt.name}
                        size={50}
                        position="relative"
                    />
                    <p className="text-xl">{prompt.name}</p>
                </div>
                <h1 className="mb-5 text-center"> {i18n.translate({ id: 'start.headline' })} </h1>
                <div className="w-full sm:w-unset absolute sm:relative bottom-0 sm:bottom-unset max-w-[768px]">
                    {chatInputComponent}
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
}

export default Home;
